import React from 'react'

export default function Collected() {
  return (
    <div>
      <div className="row-bot" style={{ display: 'block' }}>
        <div className="text-border">COLLECTED</div>
      </div>
    </div>
  )
}
